import { useParams } from 'react-router-dom'
import { ChevronUp, ChevronDown } from '@styled-icons/boxicons-solid'

import { getRequest } from '../../../../../services/base'
import { useContext, useEffect, useState } from 'react'
import {
  SalesCodeComplexityContext,
  SET_SHOW_HIDE_ERROR_LOGS,
} from '../context/context'
import Modal, { ModalBody, ModalHeader } from '../../../../common/Modal'
import { downloadErrorLogs, formatDateTime } from '../../../../../utils/common'
import NoRecordsFound from '../../../../common/NoRecordsFound'

const SalesCodeErrorLogs = () => {
  const { vehicle } = useParams()
  const [state, dispatch] = useContext(SalesCodeComplexityContext)
  const [logs, setLogs] = useState([])
  const [showLog, setShowLog] = useState(null)
  const [showMore, setShowMore] = useState({ error: 10, success: 10 })
  const [totalLogs, setTotalLogs] = useState(5)

  useEffect(() => {
    if (state.showErrorPopup) {
      getSalesCodeErroLogs(5)
    }
  }, [state.showErrorPopup])

  const getSalesCodeErroLogs = async (limit = 5) => {
    let res = await getRequest(
      `/api/plugin/sales_code/sales_code_upload_logs/${vehicle}/?limit=${limit}`
    )
    setLogs(res.data)
    setTotalLogs(res.total)
  }

  return (
    <Modal
      onClose={() => {
        dispatch({
          type: SET_SHOW_HIDE_ERROR_LOGS,
          data: false,
        })
      }}
      show={state?.showErrorPopup}
      size={'w-3/4'}
    >
      <ModalHeader className={'text-white'}>
        Sales Code Complexity Upload Logs
      </ModalHeader>
      <ModalBody>
        {logs?.map((fileObj, fileIndex) => {
          return Object.keys(fileObj.log).map((log, logIndex) => {
            return (
              <div
                className="bg-white w-full py-2 px-3 border-b border-tracer-dark-blue"
                key={`log-${logIndex}-${fileObj.id}-${fileIndex}`}
              >
                <div
                  className="bg-gray-300 flex justify-between cursor-pointer px-2 py-2"
                  onClick={() => {
                    showLog != fileObj.id
                      ? setShowLog(fileObj.id)
                      : setShowLog(null)
                  }}
                >
                  <div className="w-1/2 flex justify-between">
                    <span>{log}</span>{' '}
                  </div>
                  <div>
                    <span>{formatDateTime(fileObj.updated_at)}</span>
                    {showLog != fileObj.id ? (
                      <ChevronDown
                        size="1.5rem"
                        key={`upload-sales-file-log-down`}
                      />
                    ) : (
                      <ChevronUp
                        size="1.5rem"
                        key={`upload-sales-file-log-up`}
                      />
                    )}
                  </div>
                </div>
                {showLog == fileObj.id && (
                  <div className="flex px-4 py-2 justify-end">
                    {fileObj.log[log].error?.length > 0 && (
                      <div
                        className="px-2 underline text-blue-500 cursor-pointer"
                        onClick={() => {
                          downloadErrorLogs(fileObj.log[log].error, 'error.txt')
                        }}
                      >
                        Download Error Logs
                      </div>
                    )}
                    {fileObj.log[log].success?.length > 0 && (
                      <div
                        className="px-2 underline text-blue-500 cursor-pointer"
                        onClick={() => {
                          downloadErrorLogs(
                            fileObj.log[log].success,
                            'success.txt'
                          )
                        }}
                      >
                        Download Success Logs
                      </div>
                    )}
                  </div>
                )}
              </div>
            )
          })
        })}
        {totalLogs != logs.length && (
          <div className="flex justify-end">
            <span
              className="text-white underline cursor-pointer"
              onClick={() => {
                getSalesCodeErroLogs(logs.length + 5)
              }}
            >
              Show More
            </span>
          </div>
        )}
        {logs?.length < 1 && <NoRecordsFound />}
      </ModalBody>
    </Modal>
  )
}

export default SalesCodeErrorLogs
